import type { F2FDetails } from '@/components/F2FPreviewDialog';

function objectRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null;
}

function optionalString(value: unknown): string | undefined {
  return typeof value === 'string' ? value : undefined;
}

export function validF2FScheduleDetails(value: unknown): F2FDetails | null {
  const record = objectRecord(value);
  if (
    !record ||
    (record.interview_type !== 'online' && record.interview_type !== 'face_to_face') ||
    typeof record.scheduled_date !== 'string' ||
    !/^\d{4}-\d{2}-\d{2}$/.test(record.scheduled_date) ||
    typeof record.scheduled_time !== 'string' ||
    !/^\d{2}:\d{2}$/.test(record.scheduled_time)
  ) {
    return null;
  }

  const meetingLink = optionalString(record.meeting_link)?.trim();
  const locationLink = optionalString(record.location_link)?.trim();
  if (
    (record.interview_type === 'online' && !meetingLink) ||
    (record.interview_type === 'face_to_face' && !locationLink)
  ) {
    return null;
  }

  return {
    interview_type: record.interview_type,
    scheduled_date: record.scheduled_date,
    scheduled_time: record.scheduled_time,
    meeting_link: meetingLink,
    location_link: locationLink,
    attendee_emails: Array.isArray(record.attendee_emails)
      ? record.attendee_emails.filter((email): email is string => typeof email === 'string')
      : undefined,
    f2f_response_status: optionalString(record.f2f_response_status),
    f2f_response_reason_label: optionalString(record.f2f_response_reason_label),
    f2f_response_note: optionalString(record.f2f_response_note),
    f2f_response_at: optionalString(record.f2f_response_at),
  };
}

export function hasValidF2FSchedule(value: unknown): boolean {
  return validF2FScheduleDetails(value) !== null;
}
